<ng-template #defaultCellEditor let-column let-row="row" let-editor="editor">
  <input pInputText type="text" [(ngModel)]="row[column.key]" class="mu-table-default-editor" />
</ng-template>

<ng-template #defaultCell let-column let-row="row" let-editor="editor">
  {{ column.getValue(row) }}
</ng-template>

<ng-template #defaultFilter let-column let-filters="filters">
  <input
    pInputText
    type="text"
    class="p-inputtext p-component"
    [(ngModel)]="filters.model[column.filter]"
  />
</ng-template>
<p-table
  [id]="id"
  [columns]="columns"
  [value]="dataList?.values"
  [(expandedRowKeys)]="expandedRowKeys"
  (onRowExpand)="onRowExpand($event)"
  (onRowCollapse)="onRowCollapse($event)"
  responsiveLayout="scroll"
  styleClass="p-table mu-table {{ extraTableClasses }}"
  [scrollable]="scrollable"
  [tableStyle]="tableStyle"
  [dataKey]="dataKey"
  editMode="row"
>
  <ng-template pTemplate="caption">
    <div class="table-header p-grid p-justify-end">
      <ng-container *ngTemplateOutlet="captionTemplate"></ng-container>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th
        class="mu-responsive-display-=-none {{ column.className }}"
        *ngFor="let column of columns; trackBy: getColumnKey"
        [ngClass]="{
          'mu-table-sort': column.sortable,
          'mu-th-without-filters': filterTemplateList.length === 0
        }"
        [rowSpan]="column.withFilter ? 1 : 2"
        (click)="sort(column)"
        scope="col"
      >
        <div class="mu-display-flex mu-text-jc-left">
          <span
            [innerHTML]="
              ('context.' + contextLang + '.' + column.label.toString() | translate) + ''
            "
          ></span>
          <i
            class="fas fa-exchange-alt mu-table-sort-icon"
            [ngClass]="{
              'mu-color-blue':
                column.sortable === currentSortBy && sortDirection === sortDirectionEnum.ASC
            }"
            *ngIf="column.sortable"
            aria-hidden="true"
          ></i>
        </div>
      </th>
    </tr>
    <tr>
      <th
        *ngFor="let column of filterColumnsDefinition; trackBy: getColumnKey"
        scope="col"
        [class]="'mu-filters-table filters-' + column.key"
      >
        <ng-container
          *ngTemplateOutlet="
            column.filterTemplate;
            context: { $implicit: column, filters: filters }
          "
        ></ng-container>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colSpan="{{ columns.length }}" class="not-found" *ngIf="!showCustomNotFound">
        {{ 'context.' + contextLang + '.notFound' | translate }}
        <app-loading [showLoading]="flags.get(flagEmpty)"></app-loading>
      </td>
      <td
        colSpan="{{ columns.length }}"
        class="{{ customNotFoundClass }}"
        *ngIf="showCustomNotFound"
      >
        <ng-container *ngTemplateOutlet="notFoundTemplate"></ng-container>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row let-editing="editing" let-ri="rowIndex">
    <tr
      [class]="'default_id_' + row[bodyTrTarget]"
      id="row_{{ ri }}"
      [pSelectableRow]="row"
      [pEditableRow]="row"
      [pRowToggler]="row"
      pRipple
      (click)="_eventBodyTr($event, row[bodyTrTarget])"
    >
      <td
        *ngFor="let column of columns; trackBy: getColumnKey"
        [ngClass]="column.className"
        [ngSwitch]="column.label"
      >
        <div class="p-grid" [ngClass]="{ 'ctx-options-cell-value': column.label === 'options' }">
          <strong
            translate
            class="{{ deviceLabelClassName }} mu-mobile-header"
            [innerHTML]="'context.' + contextLang + '.' + column.label.toString() | translate"
          ></strong>
          <ng-container *ngIf="column.editable; else onlyValue">
            <p-cellEditor class="{{ deviceValueClassName }}">
              <ng-template pTemplate="input">
                <ng-container
                  *ngTemplateOutlet="
                    column.editorTemplate;
                    context: { $implicit: column, row: row, editor: rowEditor(ri) }
                  "
                ></ng-container>
              </ng-template>
              <ng-template pTemplate="output">
                <ng-container
                  *ngTemplateOutlet="
                    column.valueTemplate;
                    context: { $implicit: column, row: row, editor: rowEditor(ri) }
                  "
                ></ng-container>
              </ng-template>
            </p-cellEditor>
          </ng-container>
          <ng-template #onlyValue>
            <div class="{{ deviceValueClassName }} mu-device-mobile">
              <ng-container
                *ngTemplateOutlet="
                  column.valueTemplate;
                  context: { $implicit: column, row: row, editor: rowEditor(ri) }
                "
              ></ng-container>
            </div>
          </ng-template>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="rowexpansion" let-row let-column>
    <ng-container
      *ngTemplateOutlet="accordionTemplate; context: { $implicit: row, column }"
    ></ng-container>
  </ng-template>
</p-table>

<div
  class="p-grid mu-justify-content-center {{
    paginatorCancelRedirect !== '' ? 'mu-paginator-with-buttons' : ''
  }}"
  *ngIf="(paginator && dataList && dataList.values.length > 0) || enableButtons"
>
  <div
    class="p-col-12 p-md-12 p-lg-{{
      paginatorCancelRedirect && paginatorCancelRedirect !== '' ? '7' : '12'
    }} mu-without-padding"
  >
    <p-paginator
      *ngIf="paginator && dataList && dataList.values.length > 0"
      [rows]="dataList.limit"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      [totalRecords]="dataList.totalRows"
      currentPageReportTemplate="{{
        'paginatorLabel' | translate : { current: dataList.values.length || 0 }
      }}"
      [first]="(dataList.page - 1) * dataList.limit"
      (onPageChange)="pageChanged($event)"
    ></p-paginator>
  </div>
  <div
    [ngClass]="{ 'mu-table-button-withoutpaginator': enableButtons }"
    class="mu-form-content p-col-12 p-lg-offset-1 p-lg-4"
    *ngIf="paginatorCancelRedirect && paginatorCancelRedirect !== ''"
  >
    <app-mu-form-buttons [customGridCol]="12">
      <p-button
        muButtonLeft
        type="button"
        [label]="'form.button.cancel' | translate"
        class="mu-button mu-button-outline"
        [routerLink]="paginatorCancelRedirect"
      ></p-button>
      <p-button
        muButtonRight
        [label]="'form.button.save' | translate"
        class="mu-button"
        type="button"
        [disabled]="paginatorDisableButton"
        (click)="_eventPaginatorAction()"
      >
        <app-loading [showLoading]="paginatorButtonLoading" type="icon"></app-loading>
      </p-button>
    </app-mu-form-buttons>
  </div>
</div>
